import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {RegionModel} from '../../../../models/RegionModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {RateCardModel} from '../../../../models/RateCardModel';
import {RoleAnagrafModel} from '../../../../models/RoleAnagrafModel';
import {RateTypeModel} from '../../../../models/RateTypeModel';
import {RateCardService} from '../service-rate-card/rate-card.service';
import * as toastr from 'toastr';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';

@Component({
  selector: 'app-edit-rate-card',
  templateUrl: './edit-rate-card.component.html',
  styleUrls: ['./edit-rate-card.component.scss']
})
export class EditRateCardComponent  extends BaseGeneralComponent implements OnInit, OnDestroy {
  showActions: boolean;

  rateCard: RateCardModel;
  regionSelect: RegionModel;
  currencySelect: CurrencyModel;
  roleSelect: RoleAnagrafModel;
  rateTypeSelect: RateTypeModel;
  transition_OSselect: boolean;
  onsite_FTSselect: boolean;
  hoursSelect: number ;
  year1Select: number ;
  year1ammountSelect: number;
  year2Select: number ;
  year2ammountSelect: number;
  year3Select: number;
  year3ammountSelect: number;
  selected: string;
  saverateCard: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;
  submitted = false;
  rateCardJson: any;

  getPageSubscribe: Subscription;
  allYear: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private rateCardService: RateCardService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService) {
    super();


    this.rateCard = new RateCardModel();
    this.regionSelect = new RegionModel();
    this.currencySelect = new CurrencyModel();
    this.roleSelect = new RoleAnagrafModel();
    this.rateTypeSelect = new RateTypeModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.rateCardJson = params['row'];
        this.rateCard = JSON.parse(this.rateCardJson) as RateCardModel;
        this.regionSelect = this.rateCard.region;
        this.currencySelect = this.rateCard.currency;
        this.rateTypeSelect = this.rateCard.rateType;
        this.roleSelect = this.rateCard.roles;
        this.hoursSelect = this.rateCard.hours;
        this.onsite_FTSselect = this.rateCard.onsiteFts;
        this.transition_OSselect = this.rateCard.transitionOs;
        this.year1Select = this.rateCard.year1;
        this.year1ammountSelect = this.rateCard.year1Ammount;
        this.year2Select = this.rateCard.year2;
        this.year2ammountSelect = this.rateCard.year2Ammount;
        this.year3Select = this.rateCard.year3;
        this.year3ammountSelect = this.rateCard.year3Ammount;
      });


    this.registerForm = this.formBuilder.group({
      region: [{value: '', disabled: false}, Validators.required],
      currency: [{value: '', disabled: false}, Validators.required],
      role: [{value: '', disabled: false}, Validators.required],
      rateType: [{value: '', disabled: false}, Validators.required],
      transitionOs: [{value: '', disabled: false}, Validators.required],
      onsiteFts: [{value: '', disabled: false}, Validators.required],
      hours: [{value: '', disabled: false}, Validators.required],
      year1: [{value: '', disabled: false}, Validators.required],
      year1Ammount: [{value: '', disabled: false}, Validators.required],
      year2: [{value: '', disabled: false}, Validators.required],
      year2Ammount: [{value: '', disabled: false}, Validators.required],
      year3: [{value: '', disabled: false}, Validators.required],
      year3Ammount: [{value: '', disabled: false}, Validators.required]
    });

    this.getAllYear();


    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });

    this.registerForm.patchValue({
      currency: this.currencySelect.cod
    });

    this.registerForm.patchValue({
      role: this.roleSelect.code
    });

    this.registerForm.patchValue({
      rateType: this.rateTypeSelect.code
    });

    this.registerForm.patchValue({
      onsiteFts: this.onsite_FTSselect ? 'true' : 'false'
    });

    this.registerForm.patchValue({
      transitionOs: this.transition_OSselect ? 'true' : 'false'
    });

    this.registerForm.patchValue({
      hours: this.hoursSelect
    });

    this.registerForm.patchValue({
      year1: this.year1Select
    });

    this.registerForm.patchValue({
      year1Ammount: this.year1ammountSelect
    });

    this.registerForm.patchValue({
      year2: this.year2Select
    });

    this.registerForm.patchValue({
      year2Ammount: this.year2ammountSelect
    });

    this.registerForm.patchValue({
      year3: this.year3Select
    });

    this.registerForm.patchValue({
      year3Ammount: this.year3ammountSelect
    });

  }
  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 5}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
      this.rateCard.transitionOs = this.registerForm.value.transitionOs;
      this.rateCard.onsiteFts = this.registerForm.value.onsiteFts;
      this.rateCard.hours = this.registerForm.value.hours;
      this.rateCard.year1 = this.registerForm.value.year1;
      this.rateCard.year1Ammount = this.registerForm.value.year1Ammount;
      this.rateCard.year2 = this.registerForm.value.year2;
      this.rateCard.year2Ammount = this.registerForm.value.year2Ammount;
      this.rateCard.year3 = this.registerForm.value.year3;
      this.rateCard.year3Ammount = this.registerForm.value.year3Ammount;
      this.saverateCard = this.rateCardService.update(this.rateCardService.baseUrl, this.rateCard)
        .subscribe(
          (result: any) => {
            toastr.success('Rate Card element was edited with success', 'Success');
            this.loaderService.display(false);
            this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 5}});
          },
          error => {
            toastr.error('Rate Card element was not edited', 'Error');
            this.loaderService.display(false);
          });
    }
  }


  getAllYear() {
    this.getPageSubscribe = this.annoMeseService.getAllYear()
      .subscribe(
        (result: any) => {
          this.allYear = result;
        });
  }

  ngOnDestroy(): void {
    if (this.saverateCard) {
      this.saverateCard.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }


  handleTransitionOS(value) {
    this.rateCard.transitionOs = value;
    this.registerForm.patchValue({
      transitionOS: value
    });
  }

  handleOnsiteFTS(value) {
    this.rateCard.onsiteFts = value;
    this.registerForm.patchValue({
      onsiteFTS : value
    });
  }

  handleYear1(value) {
    this.rateCard.year1 = value;
    this.registerForm.patchValue({
      year1: value
    });
  }
  handleYear2(value) {
    this.rateCard.year2 = value;
    this.registerForm.patchValue({
      year2: value
    });
  }
  handleYear3(value) {
    this.rateCard.year3 = value;
    this.registerForm.patchValue({
      year3: value
    });
  }
}
